export class OptionRank{

    text:string;
    total:number;
    option:number;

    constructor(option:number){
        this.option = option;
    }
}


// WEBPACK FOOTER //
// ./src/app/DataStructures/OptionRank/OptionRank.ts